import { Button, Typography } from '~components/web-components'
import { Box } from '@mui/material'
import { DialogBox } from '~pages/pages-behind-login/chartering/pre-fixture-page/components/dialog-box'
import useBreakpoint from '~hooks/use-breakpoint'

interface Props {
  cancelButtonText?: string
  confirmButtonText?: string
  content?: string
  header?: string
  isVisible: boolean
  onClose?: () => void
  onConfirm?: () => void
  onCancel?: () => void
  disableCancel?: boolean
  children?: React.ReactNode
}

const ConfirmModal = ({
  content,
  header = 'Are you sure?',
  confirmButtonText = 'Yes',
  cancelButtonText = 'No',
  onConfirm,
  onClose,
  onCancel,
  isVisible,
  disableCancel,
  children,
}: Props) => {
  const { isMobileSize } = useBreakpoint()

  const handleConfirm = () => {
    onConfirm?.()
    onClose?.()
  }

  const handleCancel = () => {
    onCancel?.()
    onClose?.()
  }

  return (
    <DialogBox
      onClose={() => {
        onClose?.()
      }}
      open={isVisible}
      disablePortal={isMobileSize}
    >
      <Typography variant="h2" sx={{ mb: 4 }}>
        {header}
      </Typography>
      <Typography variant="paragraph2" sx={{ whiteSpace: 'pre-line' }}>
        {content}
      </Typography>
      {children}
      <Box
        sx={{
          display: 'flex',
          columnGap: 4,
          rowGap: 2,
          mt: 4,
          flexWrap: 'wrap',
        }}
      >
        {!disableCancel && (
          <Button variant="outlined" onClick={handleCancel}>
            {cancelButtonText}
          </Button>
        )}
        <Button variant="contained" onClick={handleConfirm}>
          {confirmButtonText}
        </Button>
      </Box>
    </DialogBox>
  )
}

export default ConfirmModal
